import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_previous_visits_list = _resolveComponent("previous-visits-list")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_ctx.request)
    ? (_openBlock(), _createBlock(_component_main_container_shell, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_base_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.translate('details.previousVisitsTitle')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_previous_visits_list)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}